import { Paginated } from "../../../../common/domain/models/paginated_models";
import { DropDown } from "../../../../common/domain/models/dropdown";
import { EmpreendimentoLista } from "../../domain/models/empreendimento_lista";
import { IIncorporacaoService } from "../services/incorporacao_service";
import { EmpreendimentoCreate } from "../../domain/models/empreendimentoCreate";
import { ListaEmpreendimentoBlocoCompletoTable } from "../../domain/models/empreendimentoBlocoTable";
import { EmpreendimentoBlocoDropDown } from "../../domain/models/empreendimento_bloco_dropdown";
import { Empreendimento } from "../../domain/models/empreendimento";
import { EmpreendimentoBloco } from '../../domain/models/empreendimentoBloco';
import { EmpreendimentoUnidade } from '../../domain/models/empreendimentoUnidade';
import { IIncorporacaoRepository } from "../../domain/repositories/incorporacao_repositories";
import { ItemServicoEmpreendimento } from "../../domain/models/item_servico_empreendimento";
import { ChecklistServicoEmpreendimento } from "../../domain/models/checklist_servico_empreendimento_lista";
import { IncorporacaoImovel } from "../../domain/models/incorporacao_imovel";


export class IncorporacaoRepository implements IIncorporacaoRepository {
    constructor(
        private readonly service: IIncorporacaoService,
    ) { }

    //#region Empreendimento
    async getAllEmprendimentoLista(
        currentPage: number,
        rowsPerPage: number
    ): Promise<Paginated<EmpreendimentoLista>> {
        const response = await this.service.getAllEmprendimentoLista({ currentPage, rowsPerPage });
        return { ...response };
    }

    async createEmpreendimento(createForm: EmpreendimentoCreate): Promise<number> {
        const response = await this.service.createEmpreendimento(createForm)
        return response.idEmpreendimento
    }

    async getEmpreendimentoBlocoTable(idBlocos: number[]): Promise<ListaEmpreendimentoBlocoCompletoTable> {
        const response = await this.service.getEmpreendimentoBlocoTable({ idBlocos })
        return { list: response }
    };

    async getEmpreendimentoBlocoDropDown(idEmpreendimento: number): Promise<EmpreendimentoBlocoDropDown[]> {
        const response = await this.service.getEmpreendimentoBlocoDropDown(idEmpreendimento)
        return [...response.item]
    };

    async updateEmpreendimento(
        idEmpreendimento: number,
        descricao: string | null,
        apresentacao: string | null
    ): Promise<void> {
        if (!idEmpreendimento) throw new Error('Falha ao atualizar Empreendimento!');

        await this.service.updateEmpreendimento({
            idEmpreendimento: idEmpreendimento,
            descricao: descricao,
            apresentacao: apresentacao
        })
    }

    async getEmpreendimentoById(idEmpreendimento: number): Promise<Empreendimento> {
        const response = await this.service.getEmpreendimentoById({ idEmpreendimento });
        return response
    }

    async updateBlocos(listBlocos: EmpreendimentoBloco[]): Promise<void> {
        await this.service.updateBlocos({ list: listBlocos })

    }

    async updateUnidades(listUnidades: EmpreendimentoUnidade[]): Promise<void> {
        await this.service.updateUnidades({
            list: listUnidades.map(unidade => ({
                ...unidade,
                descricao: unidade.descricao ?? null,
            })),
        })

    }

    async deleteBloco(idBloco: number): Promise<void> {
        await this.service.deleteBloco({ idBloco });
    }

    async deleteUnidade(idUnidade: number): Promise<void> {
        await this.service.deleteUnidade({ idUnidade });
    }

    async deleteEmpreendimento(idEmpreendimento: number): Promise<void> {
        await this.service.deleteEmpreendimento({ idEmpreendimento })
    }

    async copiaBlocos(idBloco: number, numeroCopias: number): Promise<void> {
        await this.service.copiaBlocos({ idBloco, numeroCopias });
    }

    async createUnidadesBloco(idBloco: number, andaresQuantidade: number, unidadesQuantidade: number, idAndar: number | null): Promise<void> {
        await this.service.createUnidadesBloco({ idBloco, andaresQuantidade, unidadesQuantidade, idAndar });
    }

    async createItensServicoEmpreendimento(
        idEmpreendimento: number,
        idsBloco: number[],
        idsUnidade: number[],
        idsChecklistServico: number[],
        quantidade?: number,
        valorUnitario?: number,
        salvarPorBloco?: number,
    ): Promise<number[]> {
        const response = await this.service.createItensServicoEmpreendimento({
            idEmpreendimento,
            idsBloco,
            idsUnidade,
            idsChecklistServico,
            quantidade,
            valorUnitario,
            salvarPorBloco,
        });
        return response.listaIds;
    }

    async updateItensServicoEmpreendimento(
        listaItens: ItemServicoEmpreendimento[],
    ): Promise<void> {
        await this.service.updateItensServicoEmpreendimento({ listaUpdate: listaItens });
    }

    async getAllItensServicoEmpreendimento(
        idChecklistServicoEmpreendimento?: number,
        idsChecklistServico?: number[],
        idsBloco?: number[],
        idsUnidade?: number[],
        idsItemServicoEmpreendimento?: number[],
        page?: number,
        rowsPerPage?: number
    ): Promise<Paginated<ItemServicoEmpreendimento>> {
        const response = await this.service.getAllItensServicoEmpreendimento({
            idChecklistServicoEmpreendimento,
            idsChecklistServico,
            idsBloco,
            idsUnidade,
            idsItemServicoEmpreendimento,
            page,
            rowsPerPage,
        });
        return response;
    }

    async getAllChecklistServicoEmpreendimento(
        idEmpreendimento?: number,
        idsChecklistServico?: number[],
        idsBloco?: number[],
        idsUnidade?: number[],
        idsItemServicoEmpreendimento?: number[],

        page?: number,
        rowsPerPage?: number
    ): Promise<Paginated<ChecklistServicoEmpreendimento>> {
        const response = await this.service.getAllChecklistServicoEmpreendimento({
            idEmpreendimento,
            idsChecklistServico,
            idsBloco,
            idsUnidade,
            idsItemServicoEmpreendimento,

            page,
            rowsPerPage,
        });
        return { ...response };
    }

    async getIncorporacaoImovelById(idIncorporacaoImovel: number): Promise<IncorporacaoImovel> {
        const response = await this.service.getIncorporacaoImovelById({ idIncorporacaoImovel });
        return {
            ...response,
            tipo: response.tipo == null ? response.tipo : String(response.tipo),
            nroImovel: response.nroImovel == null ? response.nroImovel : String(response.nroImovel),
        };
    }

    async deleteItensServicoEmpreendimento(
        idChecklistServicoEmpreendimento: number,
        idsItemServicoEmpreendimento: number[]
    ): Promise<void> {
        await this.service.deleteItensServicoEmpreendimento({
            idChecklistServicoEmpreendimento,
            idsItemServicoEmpreendimento,
        });
    }

    async getIncorporacaoImovelDropDown(idEmpreendimento: number, idsBlocos: number[] = []): Promise<DropDown[]> {
        const response = await this.service.getIncorporacaoImovelDropDown({ idEmpreendimento, idsBlocos });
        return [...response.item];
    }

    async updateItensServicoEmpreendimentoByConsulta(
        idChecklistServicoEmpreendimento: number,
        quantidade?: number,
        valorUnitario?: number,
    ): Promise<void> {
        await this.service.updateItensServicoEmpreendimentoByConsulta({
            idChecklistServicoEmpreendimento,
            quantidade,
            valorUnitario,
        });
    }

    //#endregion 

}
